import { Typography, TypographyProps } from '@mui/material';

import { Button, ButtonProps } from '@/components/form/baseInputs/Button';
import { XCloseIcon } from '@/components/icons/XCloseIcon';
import { COLORS } from '@/styles/tokens/colors';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';

export function OnboardingTitle({ children, ...props }: TypographyProps) {
  return (
    <Typography
      variant="h1_display"
      color="white"
      sx={{ fontSize: '42px', lineHeight: 1.2 }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export function OnboardingSubtitle({ children, ...props }: TypographyProps) {
  return (
    <Typography
      variant="title-l"
      component="h2"
      color={COLORS.NAVY[200]}
      fontWeight={FONT_WEIGHTS.light}
      {...props}
    >
      {children}
    </Typography>
  );
}

export function OnboardingSidebarButton(props: Partial<ButtonProps>) {
  return (
    <Button
      variant="transparent"
      size="sm"
      aria-label="Close"
      startIcon={XCloseIcon}
      {...props}
    />
  );
}
